export class Wallet {
  balanceCents!: number;
  balance!: string;
  currency!: string;
  pricePerCreditCents!: number;
  updatedAt!: string;

  constructor(data: any = {}) {
    this.balanceCents = data.balance_cents;
    this.balance = data.balance;
    this.currency = data.currency;
    this.pricePerCreditCents = data.price_per_credit_cents;
    this.updatedAt = data.updated_at;
  }
}
